import React from 'react';
import { translate } from '../../Services/translation';

const PagesResult = ({ filteredPages }) => {
  return (
    <ul className="quick-search-result__item-wrapper">
      {filteredPages &&
        filteredPages.map((item) => (
          <li key={`${item.name}-${item.url}`}>
            <a className="text-medium color-grey-900 lh-2" href={item.url}>
              {item.name}
            </a>
          </li>
        ))}
    </ul>
  );
};

export default PagesResult;
